import { render, staticRenderFns } from "./relevanceFrom.vue?vue&type=template&id=3148e748&scoped=true&"
import script from "./relevanceFrom.vue?vue&type=script&lang=js&"
export * from "./relevanceFrom.vue?vue&type=script&lang=js&"
import style0 from "./relevanceFrom.vue?vue&type=style&index=0&id=3148e748&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148e748",
  null
  
)

export default component.exports